import { createSlice, nanoid } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  page: 1,
  perPage: 10,
  count: 0,
  isLoading: false,
  isError: false,
  error: "",

  selectedIds: [],
  isDeleting: false,

  renderId: "",
  filters: {
    searchText: "",
    level: "",
    date: null,
  },
};

const logSlice = createSlice({
  name: "log",
  initialState: initialState,
  reducers: {
    getLogs: (state) => {
      state.isLoading = !state.renderId;
    },
    getLogsSuccess: (state, action) => {
      state.data = action.payload.rows;
      state.page = +action.payload.page;
      state.perPage = +action.payload.perPage;
      state.count = action.payload.count;
      state.isLoading = false;
      state.isError = false;
      state.error = "";
    },
    getLogsFailed: (state, action) => {
      state.data = [];
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    },

    deleteLog: (state, action) => {
      state.isDeleting = true;
    },
    deleteLogSuccess: (state, action) => {
      const deletedIds = action.payload.ids || [];
      state.selectedIds = state.selectedIds.filter((id) => !deletedIds.includes(id));
      state.renderId = nanoid(5);
      state.isDeleting = false;
    },
    deleteLogFailed: (state) => {
      state.isDeleting = false;
    },

    setLogSearchText: (state, action) => {
      state.filters.searchText = action.payload;
    },
    setLogLevel: (state, action) => {
      state.filters.level = action.payload;
    },
    setLogDate: (state, action) => {
      state.filters.date = action.payload;
    },

    selectAllLogs: (state) => {
      state.selectedIds = state.data.map((item) => item.id);
    },
    deselectAllLogs: (state) => {
      state.selectedIds = [];
    },
    selectLog: (state, action) => {
      const currentFormIndex = state.selectedIds.findIndex((selectedId) => selectedId === action.payload);
      if (currentFormIndex !== -1) {
        state.selectedIds.splice(currentFormIndex, 1);
      } else {
        state.selectedIds.push(action.payload);
      }
    },
  },
});

export const {
  getLogs,
  getLogsSuccess,
  getLogsFailed,

  deleteLog,
  deleteLogSuccess,
  deleteLogFailed,

  setLogSearchText,
  setLogLevel,
  setLogDate,

  selectAllLogs,
  deselectAllLogs,
  selectLog,
} = logSlice.actions;

export default logSlice.reducer;
